<template>
  <v-row class="unauthorized-split-display">
    <v-col lg="6" class="bg-polygon">
      <img
        src="https://user-images.githubusercontent.com/46636890/145160915-3f87ab37-3636-4c5e-a1ba-102951bb4058.png"
      />
      <div class="transparent-wrapper">
        <h1>Journal of Materials & Environmental Sustainability Research</h1>
        <h2 class="mb-5">Manuscript Submission System</h2>
        <v-btn :href="journalURL" color="white" large>
          Visit Journal Homepage
        </v-btn>
      </div>
    </v-col>
    <v-col>
      <v-card max-width="510px" class="login-wrapper">
        <div class="pa-5 d-flex align-items-center">
          <v-spacer></v-spacer>
          <v-img
            class="shrink mr-2"
            contain
            src="https://www.iceesr.org.ng/favicon.png"
            transition="scale-transition"
            width="46"
          />
        </div>
        <h3 class="py-1 text-center green accent-4 white--text text-uppercase">
          Register as Reviewer
        </h3>
        <v-card class="px-5 py-8" color="basil" flat>
          <p class="mb-10">
            Please review your information and finish your profile creation
          </p>
          <v-form class="mr-2" v-model="valid" @submit.prevent="register">
            <v-row>
              <v-col cols="5">
                <v-select
                  :items="titles"
                  outlined
                  label="Title *"
                  prepend-icon="mdi-account-outline"
                  :rules="rules.required"
                  v-model="account.title"
                ></v-select>
              </v-col>
              <v-col cols="7">
                <v-text-field
                  outlined
                  label="First Name *"
                  :rules="rules.required"
                  v-model="account.firstName"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              outlined
              label="Last Name *"
              prepend-icon="mdi-account-group-outline"
              :rules="rules.required"
              v-model="account.lastName"
            ></v-text-field>

            <v-combobox
              v-model="account.institution"
              :items="institutions"
              item-text="name"
              item-value="name"
              label="Institution name *"
              prepend-icon="mdi-school-outline"
              outlined
              :return-object="false"
              :rules="rules.required"
            ></v-combobox>

            <v-text-field
              outlined
              label="Department / College *"
              prepend-icon="mdi-office-building-outline"
              :rules="rules.required"
              v-model="account.department"
            ></v-text-field>

            <v-text-field
              outlined
              label="Specialization (optional)"
              prepend-icon="mdi-star"
              v-model="account.specialization"
            ></v-text-field>

            <v-divider class="mt-3 mb-10"></v-divider>

            <v-text-field
              outlined
              label="Email *"
              prepend-icon="mdi-at"
              :rules="rules.requiredEmail"
              v-model="account.email"
            ></v-text-field>

            <v-text-field
              outlined
              label="Phone number (optional)"
              prepend-icon="mdi-phone"
              v-model="account.phone"
            ></v-text-field>

            <v-text-field
              outlined
              label="Password *"
              prepend-icon="mdi-lock-outline"
              :rules="rules.required"
              v-model="account.password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>

            <v-text-field
              label="Confirm Password *"
              v-model="confirm"
              prepend-icon="mdi-shield-key-outline"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              outlined
              :rules="[
                (value) =>
                  value == account.password || 'Must be the same as  password',
              ]"
            ></v-text-field>

            <div class="ml-8">
              <p class="mb-7">* mark required fields.</p>
              <v-btn
                color="green"
                type="submit"
                class="white--text mr-2"
                :disabled="!valid || registering || account.password != confirm"
                :loading="registering"
              >
                Create Profile
              </v-btn>
              <v-btn color="green" text to="/login"> Login Instead </v-btn>
            </div>
          </v-form>
        </v-card>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { required, email } from "../../tools/rules";
import Institutions from "../../data/world_universities_and_domains-min.json";

export default {
  props: ["invite"],

  data: () => ({
    valid: false,
    showPassword: false,
    rules: {
      required,
      requiredEmail: [...required, ...email],
    },

    email: null,
    password: null,
    registering: false,
    confirm: null,

    account: {
      title: "",
      firstName: "",
      lastName: "",
      institution: "",
      department: "",
      specialization: null,
      email: "",
      phone: "",
      password: "",
    },

    titles: ["Dr.", "Prof.", "Mr.", "Miss."],
    institutions: Institutions,
  }),

  methods: {
    register() {
      this.registering = true;
      this.$axios
        .post(`/invites/accept/${this.invite}`, this.account)
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Registration successful",
          });

          this.$router.push({ name: "login" });
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not register, account may already exist ",
          });
        })
        .finally(() => {
          this.registering = false;
        });
    },
    loadInvite() {
      this.$axios
        .get(`/invites/${this.invite}`)
        .then(({ data: response }) => {
          this.account = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Invite not found, or has been cancelled",
          });
          this.$router.push({ name: "login" });
        })
        .finally(() => {
          this.inviting = false;
        });
    },
  },

  mounted() {
    this.loadInvite();
  },
};
</script>

